<app-home *ngIf="!isAuthenticated"></app-home>
<app-dashboard *ngIf="isAuthenticated"></app-dashboard>
